/**
 * @module Component/Basket
 * @desc The Basket Component display button with count item
 * TODO: use slot to give more flexibility to this component
 */

export default {
  /**
   * @member {type} name tag name of the component
   * @readonly
   */
  name: 'basket',
  methods: {
    /**
     * Add item to Basket disptach by BasketMediator
     * @param ev
     */
    onAddToBasket: function () {
      this.count++;
    },
    /**
     * On click on button display Basket
     * TODO can ask backend to have the list of basket item or display third part iframe
     */
    onDisplayBasket: function () {
      this.count++;
    },
  },
  /**
   * @function created
   * @desc on mounting , listen to BasketMediator Event
   */
  created: function () {
    this.on(this.globalEvent.BasketEvent.ADD, this.onAddToBasket);
    //TODO how globalEvent can be inforce by interface or documentation to help dev
    // know the property provide by plugins in foundation level or feature level
  },
  mounted: function () {
    this.on('dsfsdfsdf', this.onAddToBasket);
  },
  /**
   * @function data
   * @desc init the count number when Basket mount
   */
  data: function () {
    return {
      count: 0,
    };
  },
  computed: {
    bus: function () {},
  },
};
